/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './info.tpl.html';

angular
  .module('batch.info', [
    // including this allows html in the data bound scope properties.
    'ngSanitize',
    'services.view'
  ])
  .constant('EXPORT_SUBMIT_TYPES', {
    SELECTED: 1,
    ALL: 2,
    RECORDS: 3,
    METADATA: 4
  })
  /**
   * Controller for the batch.info template.
   */
  .controller(
    'BatchInfoCtrl',
    function (
      $scope,
      $filter,
      $state,
      $q,
      batchUtils,
      httpQueue,
      progressFactory,
      lastState,
      viewUtils,
      ALERT_EVENTS,
      EXPORT_SUBMIT_TYPES,
      VIEW_STATES
    ) {
      var batchDate;

      $scope.submitTypes = {
        selected: {
          order: 1,
          title: 'SELECTED_WITHOUT_COUNT',
          titleAlt: 'SELECTED_WITH_COUNT',
          submitType: EXPORT_SUBMIT_TYPES.SELECTED,
          type: 'selected'
        },
        all: {
          order: 2,
          title: 'ALL_RECORDS_AND_METADATA',
          titleAlt: 'ALL_RECORDS_AND_METADATA',
          submitType: EXPORT_SUBMIT_TYPES.ALL,
          type: 'all'
        },
        records: {
          order: 3,
          title: 'RECORDS_ONLY',
          titleAlt: 'RECORDS_ONLY',
          submitType: EXPORT_SUBMIT_TYPES.RECORDS,
          type: 'records'
        },
        metadata: {
          order: 4,
          title: 'METADATA_ONLY',
          titleAlt: 'METADATA_ONLY',
          submitType: EXPORT_SUBMIT_TYPES.METADATA,
          type: 'metadata'
        }
      };

      $scope.exportInProgress = progressFactory.exportInProgress;
      $scope.exportQueueInProgress = false;

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.LOG_HOME);
      };

      /**
       * Updates the info
       */
      function updateInfo() {
        if (batchUtils.currentBatch.noBackup) {
          $scope.boinkCls = 'sca-icon-question';
          batchDate = moment($scope.batchUtils.currentBatch.date);
          $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE', [batchDate.format(SBSF.messages.DOW_M_D_Y), '', '']);
          $scope.batchEmail = null;
          $scope.pctCls = 'sbsf-batch-info-shruggy';
          $scope.pctMsg = $filter('i18n')('NO_BACKUPS_AVAILABLE');
        } else {
          $scope.boinkCls =
            $scope.batchUtils.currentBatch.status && batchUtils.STATUS[$scope.batchUtils.currentBatch.status]
              ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].bigBoinkCls
              : '';

          batchDate = moment($scope.batchUtils.currentBatch.date);
          $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE', [
            batchDate.format(SBSF.messages.DOW_M_D_Y),
            batchDate.format(SBSF.messages.H_M),
            $filter('i18n')('BACKUP')
          ]);

          $scope.pctCls = function () {
            return $scope.batchUtils.currentBatch.status
              ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].textCls
              : '';
          };

          $scope.pctMsg = $filter('i18n')(
            'PERCENT_PROTECTED',
            batchUtils.getBatchPercent($scope.batchUtils.currentBatch)
          );

          // Only set the batchEmail message if the email exists and is not null
          if ($scope.batchUtils.currentBatch.userEmail) {
            $scope.batchEmail = $filter('i18n')('BATCH_EMAIL', [$scope.batchUtils.currentBatch.userEmail]);
          } else {
            $scope.batchEmail = null;
          }
        }
      }

      // If a currentBatch is empty set redirect app to the admin view.
      if (_.isEmpty($scope.batchUtils.currentBatch)) {
        $scope.goBack();
      } else {
        updateInfo();
      }

      /**
       * Handler for the export button.
       * @returns {promise} A promise that will resolve to the result of the export queue attempt.
       */
      $scope.submitExport = function () {
        var types = [],
          metadataTypes = [];
        $scope.exportQueueInProgress = true;
        if (
          $scope.$parent.allCheckedMetadata === $scope.$parent.CHECKED_STATUS.ALL &&
          $scope.$parent.allCheckedRecords === $scope.$parent.CHECKED_STATUS.ALL
        ) {
          types = 'ALL';
        } else if ($scope.selectedCount > 0 || $scope.selectedMetadataCount > 0) {
          types = $scope.selectedTypes;
          metadataTypes = $scope.selectedMetadataTypes;
        } else {
          // just return if nothing is selected.
          return $q.reject('Nothing selected for export');
        }

        return httpQueue.submitExport($scope.batchUtils.currentBatch.batchId, types, metadataTypes).then(
          function () {
            progressFactory.exportInProgress = true;
            $scope.$parent.allCheckedRecords = $scope.CHECKED_STATUS.NONE;
            $scope.$parent.allCheckedMetadata = $scope.CHECKED_STATUS.NONE;
            $scope.exportQueueInProgress = false;
          },
          function () {
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('SUBMIT_EXPORT_FAILED'));
            progressFactory.exportInProgress = false;
            $scope.exportQueueInProgress = false;
          }
        );
      };

      $scope.isNothingSelected = function () {
        return $scope.selectedCount === 0 && $scope.selectedMetadataCount === 0;
      };

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };

      // Anytime that the currentBatch changes update the info UI.
      $scope.$watch(
        function () {
          return $scope.batchUtils.currentBatch;
        },
        function () {
          updateInfo();
        }
      );

      $scope.$watch(
        function () {
          return progressFactory.exportInProgress;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            $scope.exportInProgress = newVal;
          }
        }
      );
    }
  );
